<p-dialog
  [header]="texts.HEADER"
  [modal]="true"
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '46rem' }"
  styleClass="duplicated-combination-dialog"
  (onHide)="close()">

  <div class="duplicated-combination">

    <div class="duplicated-combination__notice">
      <i class="pi pi-exclamation-triangle"></i>
      <div class="duplicated-combination__notice-body">
        <p class="duplicated-combination__lead">{{ texts.LEAD }}</p>
        <div class="duplicated-combination__combo">
          <span><span class="duplicated-combination__combo-label">Formulation:</span> {{ formulationName }}</span>
          <span><span class="duplicated-combination__combo-label">Geography:</span> {{ geographyName }}</span>
        </div>
      </div>
    </div>

    <p-table
      [value]="projects"
      [scrollable]="true"
      scrollHeight="18rem"
      styleClass="p-datatable-sm duplicated-combination__table">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ texts.COLUMN_PROJECT }}</th>
          <th>{{ texts.COLUMN_CREATED_BY }}</th>
          <th>{{ texts.COLUMN_CREATED_DATE }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-project>
        <tr>
          <td>
            <span class="duplicated-combination__name">{{ project.name }}</span>
            <span class="duplicated-combination__pk">#{{ project.projectPk }}</span>
          </td>
          <td>{{ project.createdBy }}</td>
          <td>{{ project.createdDate | date: 'dd-MMM-yyyy' }}</td>
        </tr>
      </ng-template>
    </p-table>

    <p class="duplicated-combination__hint">{{ texts.HINT }}</p>

  </div>

  <ng-template pTemplate="footer">
    <app-button
      [label]="texts.CLOSE_BUTTON"
      [icon]="'pi pi-check'"
      [severity]="'secondary'"
      [size]="'small'"
      [outlined]="true"
      (onClickEvent)="close()"></app-button>
  </ng-template>

</p-dialog>
